import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ToastService } from '../../../services/toast.service';
import { Contrato } from '../../../types/Contrato.type';
import {ContratoService} from "../../../services/contrato.service";

@Component({
  selector: 'app-contrato',
  templateUrl: './contrato.component.html',
  styleUrl: './contrato.component.css'
})
export class ContratoComponent {

  @Input() contrato: Contrato = {} as Contrato
  @Input() dialog: boolean = false;
  @Output() public fechar = new EventEmitter();

  constructor(private contratoService: ContratoService, private toastService: ToastService){

  }

  escondeDialog(){
    this.dialog = false;
    this.contrato = {} as Contrato

    this.fechar.emit();

   }

   getContrato(){
    this.contratoService.getContrato(this.contrato.instancia, this.contrato.idContrato).subscribe({
      next: (data) => {
        this.contrato = data;
      },
      error: (err) => {
          this.toastService.erro("Erro", "Erro ao abrir o contrato: " + err.message)
      },
    })
   }

}
